export default __webpack_public_path__ + "static/media/Malo.8ddf21fb.jpg";